(() => {
  angular.module('app').component('commonPatientTicketsGpHealthScreeningTreatment', {
    templateUrl: require('./widget.html'),
    controller: GpHealthScreeningTreatmentController,
    controllerAs: 'vm',
    bindings: {
      ticket: '<',
      currencyCode: '<',
    },
  });

  GpHealthScreeningTreatmentController.$inject = [];

  function GpHealthScreeningTreatmentController() {
    const vm = this;
  }
})();
